/**
 * The grabber bar at the top edge of a phone sheet: the sign that it
 * swipes down to close, now that phone sheets carry no X (owner,
 * 2026-10-23). Put it inside the element that carries the sheet's drag
 * handlers; it positions itself against the sheet panel and lets every
 * touch through to that element. `className="sm:hidden"` on a panel that
 * is a side drawer from sm up.
 */
export default function SheetGrip({ className = "" }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={`pointer-events-none absolute left-1/2 top-1.5 h-1 w-10 -translate-x-1/2 rounded-full bg-gray-300 ${className}`}
    />
  );
}
